import axios from "axios";

export const state = {
    reportcashflows: [],
};

export const getters = {
    reportcashflows: state => state.reportcashflows,
};

export const mutations = {
    setReportCashflow(reportcashflows, newValue) { state.reportcashflows = newValue},
};

export const actions = {
    async fetchReportCashflow({ commit }) {
        await axios.get('/reportcashflows').then(res => {
            commit('setReportCashflow', res.data.cashflows)
        })
    },
    async filterReportCashflow({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportcashflows";
        await axios.post(url, formData).then((response) => {
            commit('setReportCashflow', response.data.cashflows)
        })
    },
};
